import * as types from '@/store/mutation-types'
import api from '@/services/api/adminUsers'
import { buildSuccess, handleError } from '@/utils/utils.js'
import { checkIfTokenNeedsRefresh } from '@/utils/utils.js'

const getters = {
  users: state => state.users,
  totalUsers: state => state.totalUsers
}

const actions = {
  getUsers({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    commit(types.SHOW_TOP_LOADING, false)
    return new Promise((resolve, reject) => {
      api
        .getUsers(payload)
        .then(response => {
          if (response.status === 200) {
            commit(types.USERS, response.data.docs)
            commit(types.TOTAL_USERS, response.data.totalDocs)
            resolve()
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  editUser({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
      const data = {
        name: payload.name,
        email: payload.email,
        role: payload.role,
        hotspots: payload.hotspots,
        termos: payload.termos,
        oldPassword: payload.oldPassword,
        password: payload.password
      }
      api
        .editUser(payload._id, data)
        .then(response => {

          if (response.status === 200) {
              // altera local os termos
              const newValue = {
                 ...JSON.parse(window.localStorage.getItem("user")),
                 termos: true
              }
              window.localStorage.setItem("user", JSON.stringify(newValue))

            buildSuccess(
              {
                msg: 'common.SAVED_SUCCESSFULLY'
              },
              commit,
              resolve
            )
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  saveUser({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    commit(types.SHOW_LOADING, true)
    return new Promise((resolve, reject) => {
      api
        .saveUser(payload)
        .then(response => {
          if (response.status === 201) {

            buildSuccess(
              {
                msg: 'common.SAVED_SUCCESSFULLY'
              },
              commit,
              resolve, true
            )

          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  },
  deleteUser({ commit }, payload) {
    checkIfTokenNeedsRefresh()
    return new Promise((resolve, reject) => {
      api
        .deleteUser(payload._id)
        .then(response => {
          if (response.status === 200) {
            buildSuccess(
              {
                msg: 'common.DELETED_SUCCESSFULLY'
              },
              commit,
              resolve
            )
          }
        })
        .catch(error => {
          handleError(error, commit, reject)
        })
    })
  }
}

const mutations = {
  [types.USERS](state, users) {
    state.users = users
  },
  [types.TOTAL_USERS](state, value) {
    state.totalUsers = value
  }
}

const state = {
  users: [],
  totalUsers: 0
}

export default {
  state,
  getters,
  actions,
  mutations
}
